import { useEffect, type RefObject } from 'react'

/**
 * Publishes the app header's rendered height as `--app-header-h` on <html>, so
 * page content can stick right below it (`top-[var(--app-header-h)]`). The
 * height varies with the iOS safe-area inset, so it's measured, not hardcoded.
 */
export function useHeaderHeightVar(ref: RefObject<HTMLElement | null>) {
  useEffect(() => {
    const el = ref.current
    if (!el) return
    const set = () => document.documentElement.style.setProperty('--app-header-h', `${el.offsetHeight}px`)
    set()
    const observer = new ResizeObserver(set)
    observer.observe(el)
    return () => observer.disconnect()
  }, [ref])
}
